export function achievementsSlider() {

    const achievementsSlider = document.querySelector('.js-achievementsSlider');

    if (!achievementsSlider) {
        return false;
    }

    function initAchievementsSlider() {

        if (window.innerWidth > 767) {
            return false;
        }

        $('.js-achievementsSlider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'achievements_dots',
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initAchievementsSlider);

}